import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const VERB_COUNT = 12;
const CYCLE_MS = 2400;

function randomVerb(previous?: number) {
	let next = Math.floor(Math.random() * VERB_COUNT);
	// Never the same verb twice in a row, or the cycle reads as frozen.
	if (next === previous) next = (next + 1) % VERB_COUNT;
	return next;
}

/**
 * A spinner with a word: a routing-flavoured verb picked at random and swapped every
 * few seconds, so a slow load says something other than the same icon twice.
 */
export function LoadingVerb() {
	const { t } = useTranslation("routing-mode");
	const [verb, setVerb] = useState(() => randomVerb());

	useEffect(() => {
		const id = window.setInterval(
			() => setVerb((v) => randomVerb(v)),
			CYCLE_MS,
		);
		return () => window.clearInterval(id);
	}, []);

	return (
		<output className="flex items-center justify-center gap-2.5 py-12 text-sm text-muted-foreground">
			<span
				aria-hidden
				className="inline-block text-base leading-none text-primary motion-safe:animate-spin motion-safe:[animation-duration:2.4s]"
			>
				✻
			</span>
			<span key={verb} className="motion-safe:animate-in motion-safe:fade-in">
				{t(`loading.verbs.${verb}`)}…
			</span>
		</output>
	);
}
